import React from 'react'
import { IoPersonOutline } from 'react-icons/io5'
import { ClickAwayListener, Popper } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import RootStore from '../../store/RootStore'
import { toast } from 'react-toastify'
import { toastConfig } from '../../helpers/toastConfig'

type Props = {}

const UserMenu = observer((props: Props) => {
  const isAuth = RootStore.authStore.isAuth
  const isAdmin = RootStore.authStore.isAdmin
  const [open, setOpen] = React.useState(false)
  const anchorEl = React.useRef(null)
  const navigate = useNavigate()

  const hundleLogin = () => {
    setOpen(false)
    navigate('/login')
  }
  const hundleRegistration = () => {
    setOpen(false)
    navigate('/registration')
  }
  const hundleLogout = () => {
    RootStore.authStore.logout()
  }
  const hundleCheckAdmin = async () => {
    try {
      await RootStore.authStore.checkAdmin()
      toast.info('Вы зашли как Администратор', { ...toastConfig })
    } catch (error: any) {
      toast.error(error.message || 'Нет доступа', { ...toastConfig })
    }
  }

  return (
    <div className="App-header-icons" ref={anchorEl}>
      <button
        onClick={() => setOpen(!open)}
        className="App-header-icons-button"
      >
        <IoPersonOutline size={24} />
      </button>
      <Popper anchorEl={anchorEl.current} open={open}>
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <div className="Popper">
            {isAuth && !isAdmin ? (
              <>
                <button className="Popper-button" onClick={hundleCheckAdmin}>
                  Админ меню
                </button>
              </>
            ) : null}
            <div className="Auth-inputs">
              {isAuth ? (
                <>
                  <button
                    className="Auth-inputs-button Popper-button"
                    onClick={hundleLogout}
                  >
                    Выйти
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="Auth-inputs-button Popper-button"
                    onClick={hundleLogin}
                  >
                    Войти
                  </button>
                  <button
                    className="Auth-inputs-button Popper-button"
                    onClick={hundleRegistration}
                    disabled={false}
                  >
                    Зарегистрироваться
                  </button>
                </>
              )}
            </div>
          </div>
        </ClickAwayListener>
      </Popper>
    </div>
  )
})

export default UserMenu
